export { PersistentMessagesContext } from './persistent-messages-context';
export { PersistentMessagesProvider } from './persistent-messages-provider';
export type { PersistentMessage, PersistentMessagesContextType } from './types';

import { PersistentMessagesContext } from './persistent-messages-context';

import { useContext } from 'react';

// Public hook with limited API - for general use
export const usePersistentMessages = () => {
  const context = useContext(PersistentMessagesContext);

  if (!context) {
    throw new Error(
      'usePersistentMessages must be used within PersistentMessagesProvider',
    );
  }

  // Only expose addMessage and removeMessage
  return {
    addMessage: context.actions.addMessage,
    removeMessage: context.actions.removeMessage,
  };
};
